export const MODULES = [
    { id: 'capability', label: 'Capability Frontier', labelZh: 'AI 能力边界' },
    { id: 'cost_efficiency', label: 'Cost and Efficiency', labelZh: '成本与效率' },
    { id: 'usage_monetization', label: 'Usage and Monetization', labelZh: '真实使用与商业化' },
    { id: 'compute_market', label: 'Compute Infrastructure and Market', labelZh: '算力建设与市场' },
    { id: 'economic_diffusion', label: 'AI Economic Diffusion', labelZh: '职业与行业渗透' },
];

export const defineDataset = (dataset) => ({
    confidence: 'medium',
    status: 'source_snapshot',
    series: [],
    ...dataset,
});
